/* eslint-disable max-len */
/**
 * French translations.
 */
export default {
  ACTION: {
    CANCEL: 'Annuler',
    CLOSE: 'Fermer',
    CONFIRM: 'Confirmer',
    CONFIRM_AND_NEXT: 'Confirmer et suivant',
    CONFIRM_AND_SAVE: 'Confirmer et sauvegarder',
    CREATE: 'Créer',
    DELETE: 'Supprimer',
    EDIT: 'Éditer',
    NEW_POST: 'Nouvelle publication',
    OK: 'Ok',
    REJECTED: 'Rejetée',
    REPLY: 'Répondre',
    SAVE: 'Sauvegarder',
    SEND: 'Envoyer',
    SKIP_CROP: 'Ignorer la découpe',
    UPDATE: 'Mettre à jour',
    UPGRADE: 'Rejoindre le club'
  },
  ERROR: {
    FAIL_COPYING_TO_CLIPBOARD:
      'Échec lors de la copie dans le presse-papiers !',
    INSTAGRAM_PUBLISHING_ERROR:
      'Une erreur est survenue lors du partage de la publication sur Instagram.',
    INSTAGRAM_PUBLISHING_ERROR_MODAL:
      'Une erreur est survenue lors du partage de la publication sur Instagram. Voulez-vous continuer la publication ?',
    LINK_ALREADY_EXISTS: 'Ce lien existe déjà',
    LINK_VALIDATION_FAILED: 'Impossible de valider le lien',
    MANDATORY_FIELD: 'Champ obligatoire',
    MAXIMUM_CHARACTERS: 'Nombre maximum de caractères atteint',
    MAXIMUM_FILE_SIZE: 'La taille maximale autorisée est de 100 Mo !',
    MINIMUM_DIMENSIONS:
      'Le fichier téléchargé doit avoir des dimensions minimales de 480×960',
    PAGE_NOT_APPROVED:
      '❌ Malheureusement, il n’a pas été possible d’approuver ta page cette fois-ci. Mais ne t’inquiète pas ! ✨\n Tu peux modifier ton profil et corriger les champs indiqués pour le soumettre à nouveau pour approbation.',
    REACTION_LIKE: 'Une erreur est survenue, veuillez réessayer plus tard !',
    UNSUPPORTED_FORMAT: 'Format non pris en charge !',
    VIDEO_CROP: 'La découpe de la vidéo a échoué !'
  },
  HEADER: {},
  LABEL: {
    ACCEPT_TERMS_AND_CONDITIONS: 'J\'accepte les termes et conditions',
    ADDITIONAL_INFORMATION: 'Informations Complémentaires',
    ADDRESS: 'Adresse',
    APPROVED: 'publié',
    ASSETS: 'Images ou vidéos (taille maximale 100 Mo)',
    ASSOCIATE_PRODUCT: 'Associer un produit Prozis',
    ASSOCIATED_PRODUCTS: 'Produits Prozis associés',
    BUSINESS_PAGE: 'Business Page',
    CAPTION: 'Légende',
    CHART_BY: 'Graphique par',
    COMMENTS: 'Commentaires',
    COMMISSION: 'commission',
    COMMISSIONS: 'commissions',
    COMMISSIONS_LAST_30_DAYS: 'derniers 30 jours',
    COMPANY_NETWORK: 'Prozis',
    COMPLETED_WITHOUT_DOOR_NUMBER: 'Adresse complète sans numéro de maison',
    CONTINUE_WITH_INSTAGRAM: 'Continuer avec Instagram',
    COUNTRY: 'Adresse avec pays uniquement',
    CREATE_PROFILE: 'Créer un profil',
    CROPPING_ASSET: 'Découpe de {asset} {ratio}',
    DELETE_POST: 'Supprimer la publication ?',
    DELETE_POST_ARE_YOU_SURE:
      'Êtes-vous sûr de vouloir supprimer la publication ?',
    DESCRIPTION: 'Biographie',
    DOCUMENT: 'Document',
    DOWNLOAD: 'Télécharger',
    DRAFT_PROFILE: 'Brouillon',
    EDIT_PROFILE: 'Modifier la page',
    ENGAGEMENT: 'Interaction',
    ERROR: 'Erreur',
    FEED: 'fil',
    FOLLOWERS: 'Abonnés',
    FRIDAY: 'Friday',
    GALLERY: 'Galerie',
    HIDDEN: 'N\'affiche pas l\'adresse',
    IMAGE: 'image',
    INSTAGRAM: 'Instagram',
    INSTAGRAM_ACCOUNT: 'Compte Instagram',
    LATEST_FIRST: 'Les plus récentes d\'abord',
    LEAST_PROFITABLE: 'Les moins rentables en premier',
    LIKES: 'J\'aime',
    LIKES_DELETED: 'J\'aime retirés',
    LINK: 'Lien',
    LIVE: 'En direct',
    LIVES: 'Directs',
    LOCATION_LEVEL_TYPE_CITY_COUNTRY: 'Adresse avec ville et pays seulement',
    LOCATION_LEVEL_TYPE_COMPLETED: 'Adresse complète',
    LOCATION_LEVEL_TYPE_COMPLETED_WITHOUT_DOOR_NUMBER:
      'Adresse complète sans le numéro de porte',
    LOCATION_LEVEL_TYPE_COUNTRY: 'Adresse avec pays seulement',
    MONDAY: 'Monday',
    MORE: '... Voir plus',
    MOST_PROFITABLE: 'Les plus rentables en premier',
    NAME: 'Nom',
    NEW_FOLLOWERS: 'Nouveaux abonnés',
    NEW_POST: 'Nouvelle publication',
    NO_PRODUCTS_FOUND: 'Aucun produit trouvé.',
    NUMBER_OF_FILES: '{file} sur {files}',
    OLDEST_FIRST: 'Les plus anciennes d\'abord',
    ORIGINAL: 'Original',
    OTHER_NETWORKS: 'Instagram',
    PAGE_PHOTOS: 'Photos de page',
    PAST_TIME_DATE: '{value}',
    PAST_TIME_DAYS: '{value} j',
    PAST_TIME_HOURS: '{value} h',
    PAST_TIME_MINUTES: '{value} m',
    PENDING: 'en attente',
    POST: 'Publication',
    POST_COMMENTS: 'Commentaires de la publication',
    POST_PRODUCTS: 'Produits de la publication',
    POST_VIEWS: 'Vues des publications',
    POSTING_ON_INSTAGRAM: 'Publication sur Instagram',
    POSTS: 'Publications',
    PRODUCTS_HASHTAGS: 'Étiquettes de produits',
    PRODUCTS_LINKS: 'Liens vers les produits',
    PROFESSIONAL_PAGE: 'Page Professionnelle',
    PROFILE: 'Profil',
    PROFILE_PHOTO: 'Photo de profil',
    PROFILE_STATUS: 'Statut du profil',
    PROFILE_VIEWS: 'Vues du profil',
    PROZIS: 'Prozis',
    PROZIS_COMMUNITY: 'Communauté Prozis',
    QUESTION: 'Question',
    QUESTION_REPLY: 'Répondre à la question',
    QUESTIONS: 'Questions',
    REELS: 'reels',
    REJECTED: 'non publié',
    REJECTED_PROFILE: 'Rejeté',
    REJECTION_REASON: 'Raison du rejet',
    REPLY: 'Répondre',
    REQUIRED_FIELDS: 'Champs obligatoires',
    RESET: 'Réinitialiser',
    SATURDAY: 'Saturday',
    SEARCH: 'Chercher',
    SEARCH_AT_LEAST:
      'Le mot de recherche doit comporter au moins 3 caractères !',
    SEE_LESS: 'Cacher',
    SEE_MORE: 'Voir plus',
    SEE_ORIGINAL: 'Voir l\'original',
    SEE_TRANSLATION: 'Voir la traduction',
    SHARE_ON_INSTAGRAM: 'Partager sur Instagram',
    SHARE_PROFILE: 'Partager la page',
    SOCIAL_NETWORK: 'Réseau social',
    SOCIAL_NETWORK_COMMISSIONS: 'Commissions du réseau social',
    SOCIAL_NETWORK_PAGE: 'Page Sociale',
    SOUND: 'Son',
    SPECIALTIES: 'Spécialités',
    STATISTICS_POST: 'Statistiques de la publication',
    STATISTICS_PROFILE: 'Statistiques du profil',
    STATS_POST_TOTAL: 'Total des commissions de la publication',
    STATS_POST_TOTAL_COMMENTS: 'Commentaires/questions sur la publication',
    STATS_POST_TOTAL_LIKES: 'J\'aime obtenus sur la publication',
    STATS_POST_TOTAL_PRODUCTS: 'Produits associés à la publication',
    STATS_POST_TOTAL_QUESTIONS: 'Questions répondues sur la publication',
    STATS_POST_TOTAL_VALUE: 'Valeur de la publication',
    STATS_PROFILE_TOTAL: 'Total des commissions sur les publications',
    STATS_PROFILE_TOTAL_COMMENTS: 'Commentaires/questions sur les publications',
    STATS_PROFILE_TOTAL_FOLLOWERS: 'Nouveaux abonnés gagnés',
    STATS_PROFILE_TOTAL_LIKES: 'J\'aime obtenus sur les publications',
    STATS_PROFILE_TOTAL_POSTS: 'Valeur des publications',
    STATS_PROFILE_TOTAL_PRODUCTS: 'Produits associés à partir des publications',
    STATS_PROFILE_TOTAL_QUESTIONS: 'Questions répondues sur les publications',
    STORY: 'story',
    SUCCESS: 'Succès',
    SUNDAY: 'Sunday',
    TERMS_AND_CONDITIONS: 'Termes et conditions',
    THURSDAY: 'Thursday',
    TITLE: 'Titre',
    TOTAL_VIEWS: 'Total des vues',
    TUESDAY: 'Tuesday',
    TYPE_OF_DOCUMENT: 'Document type',
    UNFOLLOWERS: 'Non abonnés',
    UNREAD: 'Non lu',
    UPDATE_POST: 'Mettre à jour la publication',
    UPDATED: 'Mis à jour le {date}',
    UPLOAD: 'Télécharger un fichier',
    UPLOADING_FILES: 'Envoi du/des fichier(s)',
    USER_NAME: 'Nom d\'utilisateur',
    VIDEO: 'vidéo',
    VIEW_ALL_COMMENTS: 'Voir les {total} commentaires',
    VIEW_MORE: 'Voir plus',
    VIEWS: 'Vues',
    VISIBILITY_LEVEL: 'Niveau de visibilité',
    WAITING_APPROVAL: 'En attente d\'approbation',
    WARNING: 'Avertissement',
    WEDNESDAY: 'Wednesday',
    YOUR_PROFILE: 'Ton profil'
  },
  SENTENCE: {
    NO_QUESTIONS_YET: 'Il n\'y a pas encore de questions.',
    TERMS_AND_CONDITIONS:
      'En interagissant avec le "Réseau Social" de Prozis (par exemple, en commentant et/ou en partageant des contenus et des réactions directement), l\'Utilisateur déclare avoir lu, compris et accepté les Termes et Conditions suivants (T & C).\n\nProzis se réserve le droit de mettre à jour les Termes et Conditions à tout moment, sans préavis. Prozis se réserve le droit d\'exercer tous les recours légaux et équitables disponibles.\n\nEn accédant au "Réseau Social", l\'Utilisateur déclare avoir au moins 18 ans et assume l\'entière responsabilité des publications, commentaires, images et vidéos envoyés ("Contenu") sur ledit "Réseau Social".\n\nLe Contenu doit appartenir à l\'Utilisateur, qui déclare en être l\'auteur et détenir tous les droits de propriété intellectuelle. Le Contenu ne doit pas représenter de situation, bâtiment ou objet particulier et/ou protégé par des droits d\'auteur, une marque déposée ou, en général, des marques déposées et des logos d\'autres entreprises, à moins que l\'Utilisateur ait obtenu le consentement nécessaire pour son utilisation.\n\nLe Contenu ne doit inclure aucune autre personne que l\'Utilisateur, sauf si le consentement est donné par cette personne par écrit, et la responsabilité de l\'obtention de ce consentement incombe à l\'Utilisateur. L\'Utilisateur indemnisera et tiendra Prozis à l\'écart de tout dommage causé par l\'utilisation de telles images et/ou vidéos.\n\nUne fois partagé, le Contenu devient la propriété exclusive de Prozis, qui sera autorisée à publier et/ou diffuser et/ou utiliser et/ou reproduire et/ou communiquer et/ou modifier, par tous moyens techniques et de toute manière, ledit Contenu, sans exclusion, sans limite de temps et sans droit à aucune compensation et/ou indemnisation pour les personnes impliquées et/ou intéressées.\n\nAprès un éventuel téléchargement de Contenu, Prozis se réserve le droit de laisser visible uniquement le matériel qui, à son propre jugement incontestable, ne nuit pas à l\'image des autres, ne porte pas atteinte à la morale actuelle, ou n\'est pas autrement préjudiciable aux droits d\'autrui ; qui est partial, diffamatoire, obscène, vulgaire, calomnieux, raciste, ou constitue une forme de publicité pour toute activité commerciale non liée au sujet proposé ou qui vise à promouvoir toute marque, produit ou service autre que celui du "Réseau Social", avec un Contenu non original de l\'Utilisateur, c\'est-à-dire copié d\'autres sources, ou un contenu qui enfreint le système juridique français, contrevient à la décence publique, aux règles de confidentialité et, en général, à la législation en vigueur.\n\nProzis se réserve également le droit de supprimer, avant ou après publication, tout commentaire qui, à son seul avis, peut être offensant, inapproprié et/ou incohérent avec l\'esprit du "Réseau Social".\n\nProzis se réserve également le droit, à tout moment, de supprimer des commentaires et/ou du contenu publié sur son "Réseau Social", que ce soit de manière autonome ou à la demande de tiers, ainsi que d\'autorités judiciaires, en cas de litiges relatifs à la légalité ou à la légitimité de ladite publication ou commentaire. Ce n\'est que si le Contenu est jugé approprié par la modération du "Réseau Social" qu\'il sera laissé visible.\n\nAprès le téléchargement d\'un Contenu sur le "Réseau Social", Prozis se réserve le droit de télécharger ou de partager directement à nouveau le Contenu de l\'Utilisateur sur ses plateformes numériques pour promouvoir sa marque.',
    WITHOUT_POSTS: 'Il n\'y a pas encore de publications.',
    WITHOUT_POSTS_STATISTICS:
      'Il n\'y a pas de publications entre les dates choisies.'
  },
  SUCCESS: {
    COPIED_TO_CLIPBOARD: 'Lien copié avec succès dans le presse-papiers !',
    CREATED_SUCCESSFULLY: 'Créé avec succès !',
    ERROR_PUBLISHING_INSAGRAM: 'La publication a été publiée sur Instagram.',
    INSTAGRAM_PUBLISHING_SUCCESS:
      'La publication a été publiée avec succès sur Instagram.',
    POST_CREATED_SUCCESSFULLY: 'Créée avec succès !',
    POST_SAVED_SUCCESSFULLY: 'Mise à jour avec succès !',
    POST_SUCCESSFULLY_DELETED: 'Supprimée avec succès.',
    SAVED_SUCCESSFULLY: 'Mise à jour avec succès !',
    SUCCESSFULLY_DELETED: 'Supprimé avec succès.',
    SUCCESSFULLY_REPLIED: 'Répondu avec succès.'
  },
  TOOLTIP: {},
  WARNING: {
    ACCPET_TERMS_AND_CONDITIONS: 'Veuillez accepter les termes et conditions !',
    EMPTY_PROFILE_IMAGE: 'Vous devez télécharger une image pour le profil !',
    INVALID_FORM: 'Formulaire invalide !'
  }
};
